export const socialsData = {
    github: 'https://github.com/umeaemun',
    linkedIn: 'https://www.linkedin.com/in/ume-aemun/',
    mail: 'umeaemun@gmail.com',
}